// extracted by mini-css-extract-plugin
export default {"createInventoryGroupTitle":"styles_createInventoryGroupTitle__zrKvf","inventoryBlock":"styles_inventoryBlock__09geb","inventorySelectWrapper":"styles_inventorySelectWrapper__Odt+N"};